import { render, staticRenderFns } from "./MyFlats.vue?vue&type=template&id=96ad8694&lang=pug&"
import script from "./MyFlats.vue?vue&type=script&lang=ts&"
export * from "./MyFlats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports